export default __webpack_public_path__ + "static/media/icon-share-via-twitter.e4a6e800.svg";